(function () {
  // Prevent flicker: Show images matching selected variant immediately, then let StarApps refine
  const productLayout = document.querySelector('.product-header_layout');
  if (!productLayout) return;

  const selectedVariantId = productLayout.getAttribute('data-selected-variant');

  // Function to show images matching the selected variant initially
  function showInitialImages() {
    if (!selectedVariantId) {
      // No variant selected, show all images
      productLayout.classList.add('starapps-ready');
      return;
    }

    const gallerySlides = document.querySelectorAll('.swiper-slide.is-product-gallery');
    const thumbnailSlides = document.querySelectorAll('.swiper-slide.is-product-thumbnail');

    // Show images matching the selected variant immediately to prevent flicker
    gallerySlides.forEach((slide) => {
      const variantIds = slide.getAttribute('data-variant-ids');
      // Show if it matches selected variant OR if variant_ids is empty (image applies to all variants)
      if (!variantIds || variantIds === '' || variantIds.includes(selectedVariantId)) {
        slide.style.opacity = '1';
        slide.style.visibility = 'visible';
      }
    });

    thumbnailSlides.forEach((slide) => {
      const variantIds = slide.getAttribute('data-variant-ids');
      if (!variantIds || variantIds === '' || variantIds.includes(selectedVariantId)) {
        slide.style.opacity = '1';
        slide.style.visibility = 'visible';
      }
    });

    // Mark as ready after a short delay to let StarApps take over
    setTimeout(function () {
      productLayout.classList.add('starapps-ready');

      // Let StarApps handle visibility from now on
      // Remove inline styles so StarApps can control them
      gallerySlides.forEach((slide) => {
        slide.style.opacity = '';
        slide.style.visibility = '';
      });
      thumbnailSlides.forEach((slide) => {
        slide.style.opacity = '';
        slide.style.visibility = '';
      });
    }, 150);
  }

  // Run immediately
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showInitialImages);
  } else {
    showInitialImages();
  }

  // Preload all thumbnail images for instant display
  const thumbnailImages = document.querySelectorAll('.product_thumbnail-image');
  thumbnailImages.forEach((img) => {
    if (img.src && !img.complete) {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = img.src;
      link.setAttribute('fetchpriority', 'low');
      document.head.appendChild(link);
    }
  });
})();

// ===================================
// VIDEO & 3D MODEL GALLERY HANDLER
// ===================================
(function () {
  'use strict';

  let currentActiveSlide = null;
  let gallerySwiper = null;
  let initAttempts = 0;
  const MAX_INIT_ATTEMPTS = 50; // 5 seconds max wait
  const INIT_RETRY_DELAY = 100; // Check every 100ms

  /**
   * Stop all media in a slide
   */
  function stopMediaInSlide(slide) {
    if (!slide) return;

    const mediaType = slide.getAttribute('data-media-type');

    // Pause videos
    if (mediaType === 'video' || mediaType === 'external_video') {
      const video = slide.querySelector('video, iframe');
      if (video) {
        if (video.tagName === 'VIDEO') {
          video.pause();
          video.currentTime = 0;
        } else if (video.tagName === 'IFRAME') {
          // For external videos (YouTube, Vimeo), try to pause via postMessage
          try {
            video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            video.contentWindow.postMessage('{"method":"pause"}', '*');
          } catch (e) {
            console.log('Could not pause external video:', e);
          }
        }
      }
    }

    // Pause 3D model auto-rotation (model-viewer continues to allow manual interaction)
    if (mediaType === 'model') {
      const modelViewer = slide.querySelector('model-viewer');
      if (modelViewer) {
        modelViewer.pause();
      }
    }
  }

  /**
   * Start media in a slide
   */
  function startMediaInSlide(slide) {
    if (!slide) return;

    const mediaType = slide.getAttribute('data-media-type');

    // Autoplay videos (muted)
    if (mediaType === 'video' || mediaType === 'external_video') {
      const video = slide.querySelector('video');
      if (video) {
        video.muted = true;
        video.play().catch((err) => {
          console.log('Video autoplay prevented:', err);
        });
      }
      // Note: External videos (iframe) typically handle autoplay via their embed parameters
    }

    // Play/resume 3D model auto-rotation
    if (mediaType === 'model') {
      const modelViewer = slide.querySelector('model-viewer');
      if (modelViewer) {
        modelViewer.play();
      }
    }
  }

  /**
   * Handle slide change
   */
  function handleSlideChange(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];

    // Stop media in previous slide
    if (currentActiveSlide && currentActiveSlide !== activeSlide) {
      stopMediaInSlide(currentActiveSlide);
    }

    // Start media in new active slide
    if (activeSlide) {
      startMediaInSlide(activeSlide);
      currentActiveSlide = activeSlide;
    }
  }

  /**
   * Initialize media handlers
   */
  function initMediaHandlers() {
    // Find the gallery swiper instance
    // Swiper typically attaches instance to the DOM element
    const swiperContainer = document.querySelector('.swiper.is-product-gallery');
    
    if (!swiperContainer) {
      if (initAttempts < MAX_INIT_ATTEMPTS) {
        initAttempts++;
        setTimeout(initMediaHandlers, INIT_RETRY_DELAY);
      } else {
        console.log('Product gallery swiper not found after maximum attempts');
      }
      return;
    }

    // Check if swiper instance exists
    if (swiperContainer.swiper) {
      gallerySwiper = swiperContainer.swiper;
      
      // Add slide change listener
      gallerySwiper.on('slideChange', function() {
        handleSlideChange(gallerySwiper);
      });

      // Initialize first slide
      const firstSlide = gallerySwiper.slides[gallerySwiper.activeIndex];
      if (firstSlide) {
        currentActiveSlide = firstSlide;
        // Small delay to ensure DOM is ready
        setTimeout(() => {
          startMediaInSlide(firstSlide);
        }, 300);
      }

      console.log('✅ Product gallery media handlers initialized');
    } else {
      // Swiper not initialized yet, retry
      if (initAttempts < MAX_INIT_ATTEMPTS) {
        initAttempts++;
        setTimeout(initMediaHandlers, INIT_RETRY_DELAY);
      } else {
        console.log('Swiper instance not found after maximum attempts');
      }
    }
  }

  /**
   * Handle user interaction with videos (unmute on click)
   */
  function setupVideoInteractions() {
    document.addEventListener('click', function(e) {
      const video = e.target.closest('video.product-header_video');
      if (video) {
        // Toggle mute on video click
        video.muted = !video.muted;
      }
    });
  }

  /**
   * Setup model-viewer interactions
   */
  function setupModelViewerInteractions() {
    const modelViewers = document.querySelectorAll('model-viewer.product-header_model');
    
    modelViewers.forEach((modelViewer) => {
      // Pause auto-rotate when user starts interacting
      modelViewer.addEventListener('camera-change', function(event) {
        if (event.detail.source === 'user-interaction') {
          // User is manually rotating, pause auto-rotate temporarily
          modelViewer.removeAttribute('auto-rotate');
          
          // Resume auto-rotate after 3 seconds of no interaction
          clearTimeout(modelViewer._autoRotateTimeout);
          modelViewer._autoRotateTimeout = setTimeout(() => {
            if (modelViewer.closest('.swiper-slide-active')) {
              modelViewer.setAttribute('auto-rotate', '');
            }
          }, 3000);
        }
      });

      // Log when model is loaded
      modelViewer.addEventListener('load', function() {
        console.log('✅ 3D Model loaded successfully');
      });

      // Handle model loading errors
      modelViewer.addEventListener('error', function(e) {
        console.error('❌ 3D Model loading error:', e);
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initMediaHandlers();
      setupVideoInteractions();
      setupModelViewerInteractions();
    });
  } else {
    initMediaHandlers();
    setupVideoInteractions();
    setupModelViewerInteractions();
  }

  // Cleanup on page unload
  window.addEventListener('beforeunload', function() {
    const allSlides = document.querySelectorAll('.swiper-slide.is-product-gallery');
    allSlides.forEach(stopMediaInSlide);
  });
})();

